





















import { computed, defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { ProfileVerifyingConfirmVariant } from "@/lib/ageVerificationPurchaseGuard";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ProfileVerifyingConfirm",
  components: { BaseConfirm, BaseButton, BaseIcon },
  setup() {
    const show = ref(false);
    const variant = ref<ProfileVerifyingConfirmVariant>("purchase");

    const messageText = computed(() =>
      variant.value === "content"
        ? $t("All content will be blurred until moderation verifies your account.")
        : $t("All purchases will be blocked until moderation verifies your account.")
    );

    const showModal = (payload?: { variant?: ProfileVerifyingConfirmVariant }) => {
      variant.value = payload?.variant ?? "purchase";
      show.value = true;
    };

    const onClose = () => {
      show.value = false;
    };
    emitter.on(EVENTS.SHOW_PROFILE_VERIFYING_CONFIRM, showModal);
    onBeforeUnmount(() => emitter.off(EVENTS.SHOW_PROFILE_VERIFYING_CONFIRM, showModal));

    return {
      show,
      messageText,
      onClose,
    };
  },
});
